/**
 * Created by Xuz on 2020/01/08.
 * xuz@live.cn
 */
class TBChoicer {
  constructor (workflow) {
    this.workflow = workflow
    this.$_c = this.workflow.parent.$_c
  }

  doMouseDown (event) {
    const el = this.workflow.getSelectedElement(event)
    if (el == null) {
      this.workflow.setUnSelectLastElement(event)
      // TODO 缺少操作
    } else {
      this.workflow.setActiveElement(el, event)
    }
  }

  doMouseMove (event) {
    // TODO 缺少操作
    const el = this.workflow.getLastElement()
    el.onMove(event)
  }

  doMouseUp (event) {
    const el = this.workflow.getLastElement()
    if (el == null) {
      return
    }
    el.onUp(event)
  }

  doMouseDblClick (event) {
    const el = this.workflow.getSelectedElement(event)
    if (el == null) {
      this.workflow.setUnSelectLastElement(event)
    } else {
      if (el === this.workflow.getLastElement()) {
        el.onMouseDblClick(event)
      } else {
        this.workflow.setActiveElement(el, event)
      }
    }
  }

  getName () {
    return '选择器'
  }

  getIcon () {
    return this.$_c + 'app/workflow/img/design/choicer.png'
  }
}

export default TBChoicer
